import {
    GET_CLIENTS_INFO_START,
    GET_CLIENTS_INFO_SUCCESS,
    GET_CLIENTS_INFO_FAILURE,
} from '../constants/clients';

const INIT_STATE = {
     clientsList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action = {}) => {
    switch (action.type) {
        case GET_CLIENTS_INFO_START:
            return {
                ...state,
            };
        case GET_CLIENTS_INFO_SUCCESS:
            return {
                ...state,
                clientsList: action.payload || [],
            };
        case GET_CLIENTS_INFO_FAILURE:
            return {
                ...state,
            };

        default:
            return state;
    }
};
